import { Box } from '@mui/system';
import OtherCheckList from 'components/SS/otherChecklist';

function OtherManagment() {
  return (
    <>
      <Box sx={{ p: { xs: 3, md: 5 } }}>
        {/* <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}> */}
        {/* <Ownership
            name="Tsamina Mina"
            email="tsaminamina@email.com"
            avatar={avatar6}
            lastLoginAt="2024-11-15 15:54"
          /> */}

        {/* </Paper> */}
        <Box>
          <OtherCheckList />
        </Box>
      </Box>
    </>
  );
}

export default OtherManagment;
